import select from 'dominus';
import Headroom from 'headroom.js';
const _body = select('body');

/*
    This module configures and initialises Headroom.js which controls toggling of classes for a fixed header
    CSS needs to be provided and a base setup is included sass/components/components.header.js

    Docuents: http://wicky.nillia.ms/headroom.js/
 */

export function stickyMenu(header) {

    function isNavVisible() {
      return _body.hasClass('mobile-menu--visible');
    }

    const headroom  = new Headroom(header, {
        "offset": 90,
        "tolerance": 5,
        "classes": {
            "initial": "animated",
            "pinned": "slideDown",
            "unpinned": "slideUp"
        },
        "onUnpin": function() {
            if ( isNavVisible() ) {
              this.elem.classList.remove(this.classes.unpinned);
              this.elem.classList.add(this.classes.pinned);
            }  else {
              this.elem.classList.add(this.classes.unpinned);
              this.elem.classList.remove(this.classes.pinned);
            }
          }
    });
    headroom.init();

}




function init(config) {
    const header = select.findOne(config.header);
    stickyMenu(header);
}

export default { init: init }
